export default "__VITE_ASSET__Xyga2n9s__"